module.exports = {
  DataTable: {
    PluginName: "Tablo",
    style: "Stil",
    margin: "Margin",
    left: "Sol",
    right: "Sağ",
    top: "Üst",
    bottom: "Alt",
    padding: "Alan",
    border_width: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    border_color: "Çerçeve Rengi",
    border_radius: "Çerçeve Radyanı",
    opacity: "Opaklık",
    title: "Başlık",
    grid: "Grid",
    x_grid: "X ekseni",
    y_grid: "Y ekseni",
    line_color: "Çizgi Rengi",
    file: "Dosya Seç",
    Graph: "Grafik",
    edit: "Düzenle",
    options: {
      ascending: "Artan",
      descending: "Azalan",
      disableFilter: "Satır filtresi",
      disableRowChoice: "Satır sayısı seçicisi",
      disablePagination: "Sayfalama",
      initialPageLength: "No. Satır/Sayfa",
      initialSortProp: "Sütuna Göre Sırala",
      initialOrderProp: "Sırala",
      labels: "Etiketler",
      noDataLabel: "Tabloda Satır/Sütun Olmaması Durumunda Mesaj Metni",
      noDataLabel_txt: "Veri yok",
      pageSizeLabel: "Etiket Satır/Sayfa",
      pageSizeLabel_txt: "Satır/Sayfa",
      searchLabel: "Filtreleme Etiketi",
      searchLabel_txt: "Satırları Filtrele",
      searchPlaceholder: "Arama Kutucuğu Metni",
      searchPlaceholder_txt: "",
      example_name_surname_txt: "İsim Soyisim",
      example_age_txt: "Yaş",
      example_country_txt: "Ülke",

      examplename1: "Gamze Özverdi",
      examplename2: "Gülay Yılmaz",
      examplename3: "Kerem Atalar",
      examplename4: "Burcu Dönmez",
      examplename5: "Halil Teksoy",
      examplename6: "Kazım Sayın",
      exampleage1: "16",
      exampleage2: "23",
      exampleage3: "18",
      exampleage4: "21",
      exampleage5: "31",
      exampleage6: "37",
      examplecountry1: "Türkiye",
      examplecountry2: "Kanada",
      examplecountry3: "Avustralya",
      examplecountry4: "İngiltere",
      examplecountry5: "İrlanda",
      examplecountry6: "Almanya",
    },
    or: "Veya",
    x_axis: "X Ekseni",
    y_axis: "Y Ekseni",
    chart_type: "Grafik Türü",
    order_by: "Sırala",
    data_rows: "Satırlar",
    data_cols: "Sütunlar",
    key: "Anahtar",
    alert_msg: "Tablodaki bütün alanları doldurun",
    file_msg: "Yüklediğiniz dosyada bir sorun var",
    confirm: "Onayla",
    fill_in: "Veya bir tabloyu doldurun",
    show: "Göster",
    Row: "Satır",
    row_name: "Satır ismi",
    header: {
      options: "Tablo seçenekleri",
      origin: "Veri kaynağı",
      preview: "Ön izleme",
    },
    inline: {
      add_row: "Satır ekle",
      add_column: "Sütun ekle",
      remove_row: "Satırı sil",
      remove_column: "Sütunu sil",
      import_csv: "CSV içe aktar",
      done: "Bitti",
      header_placeholder: "Başlık",
    },
    table_settings: {
      title: "Tablo",
      show_search: "Arama kutusu",
      show_pagination: "Sayfalama",
      show_row_choice: "Satır sayısı seçicisi",
      transparent_bg: "Şeffaf arka plan",
      page_length: "Sayfa başına satır",
      sort_column: "Sıralama sütunu",
      sort_none: "Sıralama yok",
      sort_order: "Sıralama yönü",
      column_n: "Sütun {{n}}",
    },
    theme: {
      label: "Tema",
      basic: "Basit",
      striped: "Çizgili",
      "rows-only": "Sadece satırlardaki çerçeve",
      solid: "Solid Başlık",
      thick: "Kalın Çerçeve",
    },
  },
};
